import(/* webpackMode: "eager" */ "/vercel/path0/src/app/skincare-checker/page.tsx");
